module.exports = __webpack_public_path__ + "img/market.93139b0a.gif";